export function Button({
  variant = 'outline',
  type = 'button',
  className = '',
  onClick,
  disabled = false,
  title,
  children,
}: {
  variant?: 'outline' | 'primary' | 'signIn';
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  children: React.ReactNode;
}) {
  const cls =
    variant === 'signIn'
      ? `btn-si ${className}`.trim()
      : variant === 'primary'
        ? `mfb mfb-dk ${className}`.trim()
        : `mfb ${className}`.trim();

  return (
    <button type={type} className={cls} onClick={onClick} disabled={disabled} title={title}>
      {children}
    </button>
  );
}

